import { style } from '@vanilla-extract/css';
import { themeVars } from '@tundr/theme';

export const timePickerBaseClass = style({});

export const customTimePickerMenuClass = style({
  boxShadow: themeVars.shadow.elevationSmall,
  borderRadius: themeVars.radius.md,
  overflow: 'hidden',
});
